import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RoundSearch from './RoundSearch';
import ReviewFlight from './ReviewFlight';
import FareRules from './FareRules';
import SeatMap from './SeatMap';
import HoldFlight from './HoldFlight';
import BookingSession from './BookingSession';
import SyncBook from './SyncBook';
import AsyncBook from './AsyncBook';
import RetrieveBooking from './RetrieveBooking';

export default function index() {
  return (
    <Routes>
      <Route element={<RoundSearch />} path='/search' />
      <Route element={<ReviewFlight />} path='/review-flight' />
      <Route element={<FareRules />} path='/fare-rules' />
      <Route element={<SeatMap />} path='/seat-map' />
      <Route element={<HoldFlight />} path='/hold-flight' />
      <Route element={<BookingSession />} path='/booking-session' />
      <Route element={<SyncBook />} path='/book-flight' />
      <Route element={<AsyncBook />} path='/async-book' />
      <Route element={<RetrieveBooking />} path='/retrieve-booking' />
    </Routes>
  );
}
